import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Button } from "@mui/material";
import { FaEdit, FaTrash, FaCheck } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Menu } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@material-ui/icons/Save";
import Badge from "@material-ui/core/Badge";
import IconButton from "@mui/material/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@mui/material/Tooltip";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import { MuiColorInput } from "mui-color-input";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import { ApSendToCustomer_Url } from "../../../provider/ServiceUrl";
import { SUBSCRIPTION_TYPES } from "../../../provider/Enums";
import "./Plan.css";
class Plan extends Component {
  planTypeList = store.getState().adminStaticData.planTypes;
  header = store.getState().adminHeader.adminHeader;
  constructor(props) {
    super(props);
    let action = props.action;
    let plan = props.data;
    this.state = {
      customerName: "",
      customerEmail: "",
      action: action,
      operation: plan.operation,
      index: props.srno,
      name: plan.name,
      currency: plan.currency,
      price: plan.price,
      planType: plan.planType?.type,
      selectedPlanType: plan.planType,
      displaysequence: plan.displaysequence,
      validityDays: plan.validityDays,
      smsCredits: plan.smsCredits,
      overagesRate: plan.overagesRate,
      overagesBlocksize: plan.overagesBlocksize,
      colorPrimary: plan.colorPrimary,
      colorSecondary: plan.colorSecondary,
      planStatus: plan.status?.status,
      id: plan.id,
      planItems: plan.planItems,
      accountCount: plan.accountCount,
      onDelete: props.onDelete,
      addPlan: props.addPlan,
      addDuplicatePlan: props.addDuplicatePlan,
      onPlanUpdate: props.onPlanUpdate,
      onPlanDelete: props.onPlanDelete,
      businessDomain: props?.businessDomain,
      businessUseCase: props?.businessUseCase,
      businessType: props?.businessType,
      openDialogBox: false,
      customerPlanOpen: false,
      open: false,
      movePlanDetails: false,
      render: true,
      onMovePlan: props.onMovePlan,
      onPlanAccount: props.onPlanAccount,
    };
  }

  componentWillReceiveProps(props) {
    let action = props.action;
    let plan = props.data;
    this.setState({
      action: action,
      operation: plan.operation,
      index: props.srno,
      name: plan.name,
      currency: plan.currency,
      price: plan.price,
      planType: plan.planType?.type,
      selectedPlanType: plan.planType,
      displaysequence: plan.displaysequence,
      validityDays: plan.validityDays,
      smsCredits: plan.smsCredits,
      overagesRate: plan.overagesRate,
      overagesBlocksize: plan.overagesBlocksize,
      colorPrimary: plan.colorPrimary,
      colorSecondary: plan.colorSecondary,
      planStatus: plan.status?.status,
      id: plan.id,
      planItems: plan.planItems,
      accountCount: plan.accountCount,
      onDelete: props.onDelete,
      addPlan: props.addPlan,
      addDuplicatePlan: props.addDuplicatePlan,
      onPlanUpdate: props.onPlanUpdate,
      onPlanDelete: props.onPlanDelete,
      businessDomain: props?.businessDomain,
      businessUseCase: props?.businessUseCase,
      businessType: props?.businessType,
      openDialogBox: false,
      customerPlanOpen: false,
      open: false,
      movePlanDetails: false,
      render: true,
      onMovePlan: props.onMovePlan,
    });
  }
  handleEditPlan() {
    this.setState({
      action: "edit",
    });
  }
  editPlanCancel() {
    this.setState({
      action: "view",
    });
  }

  planRemove() {
    if (undefined !== this.state.onDelete && null !== this.state.onDelete) {
      this.state.onDelete(this.state);
    }
  }

  handlePlanNameChange(e) {
    this.setState({
      name: e.target.value,
    });
  }
  handlePlanPriceChange(e) {
    this.setState({
      price: e.target.value,
    });
  }

  handlePlanItemDisplaySequenceChange(e, planItem, i) {
    planItem.displaysequence = e.target.value;
    const planItemList = [...this.state.planItems];
    planItemList[i] = planItem;
    this.setState({
      planItems: planItemList,
    })
  }

  handleEditPlanItemDisplaySequenceChange = (e, planItem) => {
    const newSeq = Number(e.target.value);
    if (isNaN(newSeq)) return;

    this.setState((prev) => {
      const items = prev.planItems.map((pi) => ({ ...pi }));

      const index = items.findIndex(
        (pi) =>
          pi.operation !== "DELETE" &&
          ((pi.id && pi.id === planItem.id) ||
            (pi.tempId && pi.tempId === planItem.tempId))
      );

      if (index === -1) return null;

      // ONLY change current item
      items[index].displaysequence = newSeq;

      if (items[index].operation !== "ADD") {
        items[index].operation = "UPDATE";
      }

      return { planItems: items };
    });
  };


  handleEditPlanItemNameChange = (e, item) => {
    const value = e.target.value;

    this.setState((prev) => ({
      planItems: prev.planItems.map((pi) => {
        // Ignore deleted items
        if (pi.operation === "DELETE") return pi;

        // Match by unique identity
        const isSameItem =
          (pi.id && pi.id === item.id) ||
          (pi.tempId && pi.tempId === item.tempId);

        if (!isSameItem) return pi;

        return {
          ...pi,
          name: value,
          // Mark UPDATE only if existing item
          operation: pi.operation === "ADD" ? "ADD" : "UPDATE",
        };
      }),
    }));
  }

  handlePlanItemNameChange(e, planItem, i) {
    planItem.name = e.target.value;
    const planItemList = [...this.state.planItems];
    planItemList[i] = planItem;
    this.setState({
      planItems: planItemList,
    });
  }

  handlePlanTypeChanges(e) {
    let planType = e.target.value;
    const selectedPlanType = this.planTypeList.find(
      (option) => option.type === planType
    );
    this.setState({
      planType: planType,
      selectedPlanType: selectedPlanType,
    });
  }

  handlePlanStatusChange(e) {
    let planStatus = e.target.value;
    this.setState({
      planStatus: planStatus,
    });
  }
  handleDisplaySequenceChange(e) {
    this.setState({
      displaysequence: e.target.value,
    });
  }

  // addPlanItem = (afterSeq) => {
  //   this.setState((prev) => {
  //     let items = prev.planItems.map((pi) => ({ ...pi }));

  //     items.forEach((pi) => {
  //       if (pi.operation !== "DELETE" && pi.displaysequence > afterSeq) {
  //         pi.displaysequence += 1;
  //       }
  //     });

  //     items.push({
  //       operation: "ADD",
  //       id: "",
  //       displaysequence: afterSeq + 1,
  //       name: "",
  //       isFontBold: false,
  //       isFontItalic: false,
  //       isFontSmall: false,
  //     });

  //     // Normalize
  //     items = items
  //       .filter((pi) => pi.operation !== "DELETE")
  //       .sort((a, b) => a.displaysequence - b.displaysequence)
  //       .map((pi, index) => ({
  //         ...pi,
  //         displaysequence: index + 1,
  //       }));

  //     return { planItems: items };
  //   });
  // };

  addPlanItem = (afterSeq) => {
    this.setState((prev) => {
      // Clone
      let items = prev.planItems.map((pi) => ({ ...pi }));

      // ACTIVE items only
      const activeItems = items.filter(
        (pi) => pi.operation !== "DELETE"
      );

      // New displaysequence = length of active items + 1
      const newDisplaySequence = activeItems.length + 1;

      // Add new item
      const newItem = {
        tempId: `TMP_${Date.now()}_${Math.random()}`,
        operation: "ADD",
        id: "",
        displaysequence: newDisplaySequence,
        name: "",
        isFontBold: false,
        isFontItalic: false,
        isFontSmall: false,
      };

      items.push(newItem);

      return { planItems: items };
    });
  };

  planItemRemove(item) {
    this.setState((prev) => {
      const planItems = prev.planItems
        .map((pi) =>
          pi.displaysequence === item.displaysequence &&
            pi.operation === "UPDATE"
            ? { ...pi, operation: "DELETE" }
            : pi
        )
        .filter(
          (pi) =>
            !(
              pi.operation === "ADD" &&
              pi.displaysequence === item.displaysequence
            )
        );
      return { planItems };
    });
  }

  planEditItemRemove = (item) => {
    this.setState((prev) => {
      let items = prev.planItems
        .map((pi) => {
          // Existing item → mark DELETE
          if (
            pi.id &&
            pi.id === item.id &&
            pi.operation !== "ADD"
          ) {
            return { ...pi, operation: "DELETE" };
          }
          return pi;
        })
        // New item → remove directly
        .filter(
          (pi) =>
            !(
              pi.operation === "ADD" &&
              pi.tempId === item.tempId
            )
        );

      return { planItems: items };
    });
  };

  addPlan() {
    let displaysequenceList = [];
    for (let i = 0; i < this.state.planItems.length; i++) {
      const displaysequence = this.state.planItems[i].displaysequence;
      displaysequenceList.push(parseFloat(displaysequence));
    }
    let isDuplicate =
      new Set(displaysequenceList).size !== displaysequenceList.length;
    if (isDuplicate) {
      PtsAlert.error(
        "Plan items display sequence is already in use. Please enter a unique value."
      );
      return;
    }
    if (undefined !== this.state.addPlan && null !== this.state.addPlan) {
      // this.setState({ action: "create" });
      this.state.addPlan(this.state);
    }
  }
  updatePlan() {
    let displaysequenceList = [];

    for (let i = 0; i < this.state.planItems.length; i++) {
      if (this.state.planItems[i].operation !== "DELETE") {
        const displaysequence = this.state.planItems[i].displaysequence;
        displaysequenceList.push(parseFloat(displaysequence));
      }
    }
    let isDuplicate =
      new Set(displaysequenceList).size !== displaysequenceList.length;
    if (isDuplicate) {
      PtsAlert.error(
        "Plan items display sequence is already in use. Please enter a unique value."
      );
      return;
    }
    if (
      undefined !== this.state.onPlanUpdate &&
      null !== this.state.onPlanUpdate
    ) {
      this.state.onPlanUpdate(this.state);
      // this.setState({ action: "view" });
    }
  }

  backToViewAction() {
    if (
      undefined !== this.props.onPlanCancel &&
      null !== this.props.onPlanCancel
    ) {
      this.props.onPlanCancel(this.state);
    }
  }

  handleClickOpenDialogBox() {
    this.setState({ openDialogBox: true });
  }
  handleCloseDialogBox() {
    this.setState({ openDialogBox: false });
  }

  handleDeletePlan(e, id) {
    this.setState({ id: id });
    if (
      undefined !== this.state.onPlanDelete &&
      null !== this.state.onPlanDelete
    ) {
      this.state.onPlanDelete(this.state);
      this.setState({ action: "view", render: true });
    }
  }

  handleColorPrimaryChage(color) {
    this.setState({
      colorPrimary: color,
    });
  }

  handleColorSecondaryChage(color) {
    this.setState({
      colorSecondary: color,
    });
  }

  handleValidityDaysChange(e) {
    this.setState({
      validityDays: e.target.value,
    });
  }
  handleSmsCreditsChange(e) {
    this.setState({
      smsCredits: e.target.value,
    });
  }
  handleOveragesRateChange(e) {
    this.setState({
      overagesRate: e.target.value,
    });
  }
  handleOveragesBlocksizeChange(e) {
    this.setState({
      overagesBlocksize: e.target.value,
    });
  }
  toPlanAccountDetails(planId) {
    if (
      undefined !== this.state.onPlanAccount &&
      null !== this.state.onPlanAccount
    ) {
      this.state.onPlanAccount(planId, this.state.name);
    }
    // this.props.navigate("/planAccountList", {
    //   state: {
    //     planId: planId,
    //     planName: this.state.name,
    //     businessUseCase: this.props.businessUseCase,
    //     businessDomain: this.props?.businessDomain,
    //     businessType: this.props?.businessType,
    //   },
    // });
  }

  addDuplicatePlan = () => {
    this.state.addDuplicatePlan(this.state);
  };

  handleCustomerPlanOpenDialogBox() {
    this.setState({
      customerPlanOpen: true,
    });
  }
  handleCustomerPlanCloseDialogBox() {
    this.setState({
      customerPlanOpen: false,
    });
  }

  sendCustomPlanToCustomer() {
    const postObject1 = {
      header: this.header,
      customerCustomPlan: {
        planId: this.state.id,
        name: this.state.customerName,
        customerEmail: this.state.customerEmail,
      },
    };
    AdminFetchServerData.callPostService(
      ApSendToCustomer_Url,
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          customerPlanOpen: false,
          customerName: "",
          customerEmail: "",
        });
      }
    });
  }

  handleCustomerNameChange(e) {
    this.setState({
      customerName: e.target.value,
    });
  }
  handleCustomerEmailChange(e) {
    this.setState({
      customerEmail: e.target.value,
    });
  }
  handleMovePlanDetailsOpen(selectedPlanId) {
    if (
      undefined !== this.state.onPlanDelete &&
      null !== this.state.onPlanDelete
    ) {
      this.state.onMovePlan(selectedPlanId);
    }
  }

  handleAccountDropdownOpen = (event, planItem, index) => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
      selectedIndex: index,
    });
  };

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleToggleBold = (planItemIndex) => {
    this.setState((prevState) => {
      const planItems = [...prevState.planItems];
      planItems[planItemIndex].isFontBold =
        !planItems[planItemIndex].isFontBold;
      return { planItems };
    });
  };

  handleToggleItalic = (planItemIndex) => {
    this.setState((prevState) => {
      const planItems = [...prevState.planItems];
      planItems[planItemIndex].isFontItalic =
        !planItems[planItemIndex].isFontItalic;
      return { planItems };
    });
  };
  handleToggleFontSize = (planItemIndex) => {
    this.setState((prevState) => {
      const planItems = [...prevState.planItems];
      planItems[planItemIndex].isFontSmall =
        !planItems[planItemIndex].isFontSmall;
      return { planItems };
    });
  };

  textSetting() {
    return (
      <Menu
        anchorEl={this.state.anchorEl}
        id="dropdown-menu"
        open={this.state.open}
        onClose={this.handleAccountDropdownClose}
        // onClick={this.handleAccountDropdownClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 20,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div className="d-flex ps-2 pe-2">
          <MenuItem
            className="p-2"
            onClick={() => this.handleToggleBold(this.state.selectedIndex)}
          >
            <FormatBoldIcon
              fontSize="small"
              style={{
                color: this.state.planItems[this.state.selectedIndex]
                  ?.isFontBold
                  ? "#37517e"
                  : "#777",
              }}
            />
          </MenuItem>
          <MenuItem
            className="p-2"
            onClick={() => this.handleToggleItalic(this.state.selectedIndex)}
          >
            <FormatItalicIcon
              fontSize="small"
              style={{
                color: this.state.planItems[this.state.selectedIndex]
                  ?.isFontItalic
                  ? "#37517e"
                  : "#777",
              }}
            />
          </MenuItem>
          <MenuItem
            className="p-2"
            onClick={() => this.handleToggleFontSize(this.state.selectedIndex)}
          >
            <FormatSizeIcon
              fontSize="small"
              style={{
                color: this.state.planItems[this.state.selectedIndex]
                  ?.isFontSmall
                  ? "#37517e"
                  : "#777",
              }}
            />
          </MenuItem>
        </div>
      </Menu>
    );
  }

  render() {
    if (this.state.action === "create") {
      return this.createPlan();
    } else if (this.state.action === "edit") {
      return this.editPlan();
    } else if (this.state.action === "duplicate") {
      return this.createDuplicatePlan();
    } else {
      return this.viewPlan();
    }
  }
  createPlan() {
    return (
      <div className="row d-flex" style={{ height: "100%" }}>
        <div className="col-md-12">
          <div
            className="box"
            data-aos="zoom-in"
            data-aos-delay={100}
            style={{
              padding: "0em",
              position: "relative",
              height: "100%",
              overflow: "auto",
              backgroundColor: "white",
            }}
            id="regPlanBox"
          >
            <div className="plan-inner plan_card plan_card_bottom">
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.addPlan.bind(this)}
              >
                <div
                  class="row"
                  className="entry-title plan_card"
                  style={{ background: this.state.colorSecondary }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      background: this.state.colorPrimary,
                    }}
                  >
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="text"
                      autoComplete="off"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Enter Plan Name"
                      value={this.state.name}
                      onChange={this.handlePlanNameChange.bind(this)}
                      validators={["required"]}
                      errormessages={["This field is required"]}
                      style={{
                        padding: "7px",
                        color: "#fff",
                        margin: "1% 10%",
                      }}
                    />
                  </div>
                  <div
                    className="price"
                    style={{
                      background: this.state.colorPrimary,
                    }}
                  >
                    <input
                      type="number"
                      name="price"
                      size="small"
                      title=""
                      required
                      value={this.state.price}
                      onChange={this.handlePlanPriceChange.bind(this)}
                      placeholder="$Price"
                      style={{
                        fontSize: "18px", // Set a smaller font size
                        width: "80px",
                        height: "40px",
                        marginleft: "9px",
                        borderRadius: "10px",
                        textAlign: "center",
                      }}
                    />
                  </div>
                </div>
                <div className="entry-content" style={{ padding: "0px 15px" }}>
                  <ul>
                    {this.state.planItems.length === 0 && (
                      <li style={{ padding: "0.5em" }}>
                        <div
                          className="row p-1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "#ececec",
                          }}
                        >
                          <Tooltip title="Add Plan Item" arrow>
                            {" "}
                            <Button
                              style={{
                                background: "#37517e",
                                color: "#fff",
                                borderColor: "#37517e",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                              }}
                              className="btn btn-info rounded-circle btn-sm"
                              type="button"
                              onClick={() => this.addPlanItem(0)}
                            >
                              <AddIcon
                                style={{
                                  fontSize: "16px",
                                  color: "#fff",
                                }}
                              />{" "}
                            </Button>
                          </Tooltip>
                        </div>
                      </li>
                    )}
                    {this.state.planItems.map((planItem, i) => (
                      <li key={i} style={{ padding: "0.5em" }}>
                        <div
                          class="row"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="col-md-2">
                            <input
                              type="number"
                              className="form-control"
                              style={{
                                width: "100%",
                                margin: "0 auto",
                                display: "block",
                                padding: "0.4375rem",
                                textAlign: "right",
                                height: "32px",
                              }}
                              value={planItem.displaysequence}
                              onChange={(e) =>
                                this.handlePlanItemDisplaySequenceChange(
                                  e,
                                  planItem,
                                  i
                                )
                              }
                              onFocus={(event) => {
                                event.target.select();
                              }}
                            />
                          </div>
                          <div className="col-md-7">
                            <input
                              title=""
                              type="text"
                              required
                              className="form-control"
                              style={{
                                fontWeight: planItem.isFontBold && "600",
                                fontStyle: planItem.isFontItalic && "italic",
                                fontSize: planItem.isFontSmall && "12px",
                                height: "32px",
                              }}
                              placeholder="Plan Item"
                              value={planItem.name}
                              autoFocus={true}
                              onChange={(e) =>
                                this.handlePlanItemNameChange(e, planItem, i)
                              }
                            />
                          </div>
                          <div
                            class="col-md-3 p-0"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              // justifyContent: "space-between",
                            }}
                          >
                            {i === this.state.planItems.length - 1 && (
                              <Tooltip title="Add Plan Item" arrow>
                                {" "}
                                <Button
                                  style={{
                                    background: "#37517e",
                                    color: "#fff",
                                    borderColor: "#37517e",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    width: "28px",
                                    height: "28px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    float: "right",
                                    padding: "0",
                                    minWidth: "0",
                                    border: "none",
                                  }}
                                  className="btn btn-info rounded-circle btn-sm me-1"
                                  type="button"
                                  onClick={() =>
                                    this.addPlanItem(planItem.displaysequence)
                                  }
                                >
                                  <AddIcon
                                    style={{
                                      fontSize: "16px",
                                      color: "#fff",
                                    }}
                                  />{" "}
                                </Button>
                              </Tooltip>
                            )}
                            <Button
                              className="add me-1"
                              style={{
                                background: "#867e7e",
                                color: "white",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                                marginleft: "2px",
                              }}
                              onClick={(e) =>
                                this.handleAccountDropdownOpen(e, planItem, i)
                              }
                            >
                              <MoreVertIcon style={{ fontSize: "16px" }} />
                            </Button>
                            <Button
                              className="add"
                              style={{
                                background: "#867e7e",
                                color: "white",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                                marginleft: "2px",
                              }}
                              onClick={this.planItemRemove.bind(
                                this,
                                planItem,
                                i
                              )}
                            >
                              <DeleteIcon style={{ fontSize: "16px" }} />{" "}
                            </Button>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  {this.textSetting()}
                </div>
                <hr></hr>
                <div style={{ padding: "0.4em 1em" }}>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Primary Color</label>
                      <MuiColorInput
                        format="hex"
                        variant="outlined"
                        size="small"
                        className="planMuiColorInput"
                        value={this.state.colorPrimary}
                        onChange={this.handleColorPrimaryChage.bind(this)}
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Secondary Color</label>
                      <MuiColorInput
                        format="hex"
                        variant="outlined"
                        size="small"
                        className="planMuiColorInput"
                        value={this.state.colorSecondary}
                        onChange={this.handleColorSecondaryChage.bind(this)}
                      />
                    </div>
                  </div>
                  {!(
                    this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                    this.state.planType === SUBSCRIPTION_TYPES.payMonthly
                  ) && (
                      <div class="row mt-2">
                        <div class="col-md-6">
                          <label class="form-label fw-bold">Subscription</label>
                          <select
                            name="subscriptionType"
                            style={{
                              width: "100%",
                              padding: "0px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                              fontSize: "16px",
                              color: "#495057",
                              backgroundColor: "#fff",
                              height: "32px",
                            }}
                            value={this.state.planType}
                            onChange={this.handlePlanTypeChanges.bind(this)}
                          >
                            <option value="">Select Subscription</option>
                            {this.planTypeList.map((option, index) => (
                              <option key={index} value={option.type}>
                                {option.description}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  <div class="row mt-2">
                    {this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                      this.state.planType === SUBSCRIPTION_TYPES.payMonthly ? (
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Subscription</label>
                        <select
                          name="subscriptionType"
                          style={{
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ced4da",
                            boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                            fontSize: "16px",
                            color: "#495057",
                            backgroundColor: "#fff",
                            height: "32px",
                          }}
                          value={this.state.planType}
                          onChange={this.handlePlanTypeChanges.bind(this)}
                        >
                          <option value="">Select Subscription</option>
                          {this.planTypeList.map((option, index) => (
                            <option key={index} value={option.type}>
                              {option.description}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Texting Window</label>
                        <input
                          title=""
                          required
                          type="number"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="smsCredits"
                          className="form-control"
                          style={{ height: "32px", padding: "0px 8px" }}
                          value={this.state.validityDays}
                          onChange={this.handleValidityDaysChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    )}
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Status</label>
                      <select
                        name="planStatus"
                        value={this.state.planStatus}
                        onChange={this.handlePlanStatusChange.bind(this)}
                        style={{
                          width: "100%",
                          padding: "0px 8px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                          fontSize: "16px",
                          color: "#495057",
                          backgroundColor: "#fff",
                          height: "32px",
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="Active" id="1">
                          Active
                        </option>
                        <option value="InActive" id="2">
                          InActive
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">SMS Credits</label>
                      <input
                        required
                        title=""
                        type="number"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.smsCredits}
                        onChange={this.handleSmsCreditsChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Plan Display Seq</label>
                      <input
                        title=""
                        required
                        type="number"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="displaysequence"
                        className="form-control"
                        value={this.state.displaysequence}
                        onChange={this.handleDisplaySequenceChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                        style={{
                          width: "100%",
                          padding: "0px 8px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          fontSize: "16px",
                          color: "#495057",
                          backgroundColor: "#fff",
                          height: "32px",
                        }}
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Overages Rate</label>
                      <input
                        required
                        title=""
                        type="text"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.overagesRate}
                        onChange={this.handleOveragesRateChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>

                    <div class="col-md-6">
                      <label class="form-label fw-bold">Overages Block</label>
                      <input
                        required
                        title=""
                        type="text"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.overagesBlocksize}
                        onChange={this.handleOveragesBlocksizeChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="p-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Save plan" arrow>
                    <Button
                      type="submit"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "26px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                        minWidth: "0",
                        border: "none",
                        margin: "0 5px",
                      }}
                    >
                      <FaCheck style={{ fontSize: "20px" }} />{" "}
                    </Button>
                  </Tooltip>

                  <Tooltip title="Cancel" arrow>
                    {" "}
                    <Button
                      className="add"
                      style={{
                        backgroundColor: "#867e7e",
                        color: "white",
                        fontSize: "26px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                        minWidth: "0",
                        border: "none",
                        margin: "0 5px",
                      }}
                      onClick={this.planRemove.bind(this)}
                    >
                      <CancelIcon style={{ fontSize: "20px" }} />{" "}
                      {/* Adjust icon size */}
                    </Button>
                  </Tooltip>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
  editPlan() {
    const visibleItems = this.state.planItems.filter(
      (item) => item.operation !== "DELETE"
    );
    return (
      <>
        <div className="row d-flex" style={{ height: "100%" }}>
          <div className="col-md-12">
            <div
              className="box"
              data-aos="zoom-in"
              data-aos-delay={100}
              style={{
                padding: "0em",
                position: "relative",
                height: "100%",
                overflow: "auto",
                backgroundColor: "white",
              }}
              id="regPlanBox"
            >
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.updatePlan.bind(this)}
              >
                <div className="plan-inner plan_card plan_card_bottom">
                  <div
                    class="row"
                    className="entry-title plan_card"
                    style={{ background: this.state.colorSecondary }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        background: this.state.colorPrimary,
                      }}
                    >
                      {" "}
                      <input
                        title=""
                        required
                        type="text"
                        autoComplete="off"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Enter Plan Name"
                        value={this.state.name}
                        onChange={this.handlePlanNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                        style={{
                          padding: "7px",
                          color: "#fff",
                          margin: "1% 10%",
                        }}
                      />
                    </div>
                    <div
                      className="price"
                      style={{
                        background: this.state.colorPrimary,
                      }}
                    >
                      <input
                        type="number"
                        name="price"
                        size="small"
                        title=""
                        required
                        value={this.state.price}
                        onChange={this.handlePlanPriceChange.bind(this)}
                        placeholder="$Price"
                        style={{
                          fontSize: "18px", // Set a smaller font size
                          width: "80px",
                          height: "40px",
                          marginleft: "9px",
                          borderRadius: "10px",
                          textAlign: "center",
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="entry-content"
                    style={{ padding: "0px 15px" }}
                  >
                    <ul>
                      {this.state.planItems.filter(
                        (item) => item.operation !== "DELETE"
                      ).length === 0 && (
                          <li style={{ padding: "0.5em" }}>
                            <div
                              className="row p-1"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                                background: "#ececec",
                              }}
                            >
                              <Tooltip title="Add Plan Item" arrow>
                                <Button
                                  style={{
                                    background: "#37517e",
                                    color: "#fff",
                                    borderColor: "#37517e",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    float: "right",
                                    padding: "0",
                                    minWidth: "0",
                                    border: "none",
                                  }}
                                  className="btn btn-info rounded-circle btn-sm"
                                  type="button"
                                  onClick={() => this.addPlanItem(0)}
                                >
                                  <AddIcon
                                    style={{ fontSize: "16px", color: "#fff" }}
                                  />
                                </Button>
                              </Tooltip>
                            </div>
                          </li>
                        )}

                      {visibleItems.map((planItem, i) => (
                        <>
                          {planItem.operation !== "DELETE" && (
                            <li key={i} style={{ padding: "0.5em" }}>
                              <div
                                className="row"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div className="col-md-2">
                                  {/* <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    width: "100%",
                                    margin: "0 auto",
                                    display: "block",
                                    padding: "0.4375rem",
                                    textAlign: "center",
                                  }}
                                  value={planItem.displaysequence}
                                  onChange={(e) =>
                                    this.handlePlanItemDisplaySequenceChange(
                                      e,
                                      planItem,
                                      idx
                                    )
                                  }
                                /> */}
                                  <input
                                    type="number"
                                    className="form-control"
                                    style={{
                                      width: "100%",
                                      margin: "0 auto",
                                      display: "block",
                                      padding: "0.4375rem",
                                      textAlign: "right", // ✅ Right aligned
                                      height: "32px",
                                    }}
                                    value={planItem.displaysequence}
                                    onChange={(e) =>
                                      this.handleEditPlanItemDisplaySequenceChange(
                                        e,
                                        planItem,
                                        i
                                      )
                                    }
                                    onFocus={(event) => {
                                      event.target.select();
                                    }}
                                  />
                                </div>

                                <div className="col-md-7">
                                  <input
                                    type="text"
                                    title=""
                                    required
                                    className="form-control"
                                    placeholder="Plan Item"
                                    style={{
                                      fontWeight: planItem.isFontBold && "600",
                                      fontStyle:
                                        planItem.isFontItalic && "italic",
                                      fontSize: planItem.isFontSmall && "12px",
                                      height: "32px",
                                    }}
                                    value={planItem.name}
                                    autoFocus={true}
                                    onChange={(e) =>
                                      this.handleEditPlanItemNameChange(
                                        e,
                                        planItem,
                                        i
                                      )
                                    }
                                  />
                                </div>

                                <div
                                  className="col-md-3 p-0"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    // justifyContent: "space-between",
                                  }}
                                >
                                  {i === visibleItems?.length - 1 && (
                                    <Tooltip title="Add Plan Item" arrow>
                                      <Button
                                        style={{
                                          background: "#37517e",
                                          color: "#fff",
                                          borderColor: "#37517e",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          borderRadius: "50%",
                                          width: "28px",
                                          height: "28px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          float: "right",
                                          padding: "0",
                                          minWidth: "0",
                                          border: "none",
                                        }}
                                        className="btn btn-info rounded-circle btn-sm me-1"
                                        type="button"
                                        onClick={() =>
                                          this.addPlanItem(
                                            planItem.displaysequence
                                          )
                                        }
                                      >
                                        <AddIcon
                                          style={{
                                            fontSize: "16px",
                                            color: "#fff",
                                          }}
                                        />
                                      </Button>
                                    </Tooltip>
                                  )}
                                  <Button
                                    className="add me-1"
                                    style={{
                                      background: "#867e7e",
                                      color: "white",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      width: "28px",
                                      height: "28px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      float: "right",
                                      padding: "0",
                                      minWidth: "0",
                                      border: "none",
                                      marginleft: "2px",
                                    }}
                                    onClick={(e) =>
                                      this.handleAccountDropdownOpen(
                                        e,
                                        planItem,
                                        i
                                      )
                                    }
                                  >
                                    <MoreVertIcon
                                      style={{ fontSize: "16px" }}
                                    />
                                  </Button>
                                  <Button
                                    className="add"
                                    style={{
                                      background: "#867e7e",
                                      color: "white",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      width: "28px",
                                      height: "28px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      float: "right",
                                      padding: "0",
                                      minWidth: "0",
                                      border: "none",
                                      marginleft: "2px",
                                    }}
                                    onClick={() =>
                                      this.planEditItemRemove(planItem, i)
                                    }
                                  >
                                    <DeleteIcon style={{ fontSize: "16px" }} />
                                  </Button>
                                </div>
                              </div>
                            </li>
                          )}
                        </>
                      ))}
                    </ul>
                    {this.textSetting()}
                  </div>
                  <hr></hr>
                  <div style={{ padding: "0.4em 1em" }}>
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Primary Color</label>
                        <MuiColorInput
                          format="hex"
                          variant="outlined"
                          size="small"
                          className="planMuiColorInput"
                          value={this.state.colorPrimary}
                          onChange={this.handleColorPrimaryChage.bind(this)}
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-bold">
                          Secondary Color
                        </label>
                        <MuiColorInput
                          format="hex"
                          variant="outlined"
                          size="small"
                          className="planMuiColorInput"
                          value={this.state.colorSecondary}
                          onChange={this.handleColorSecondaryChage.bind(this)}
                        />
                      </div>
                    </div>
                    {!(
                      this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                      this.state.planType === SUBSCRIPTION_TYPES.payMonthly
                    ) && (
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <label class="form-label fw-bold">Subscription</label>
                            <select
                              name="subscriptionType"
                              style={{
                                width: "100%",
                                padding: "0px 8px",
                                borderRadius: "4px",
                                border: "1px solid #ced4da",
                                boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                                fontSize: "16px",
                                color: "#495057",
                                backgroundColor: "#fff",
                                height: "32px",
                              }}
                              value={this.state.planType}
                              onChange={this.handlePlanTypeChanges.bind(this)}
                            >
                              <option value="">Select Subscription</option>
                              {this.planTypeList.map((option, index) => (
                                <option key={index} value={option.type}>
                                  {option.description}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    <div class="row mt-2">
                      {this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                        this.state.planType === SUBSCRIPTION_TYPES.payMonthly ? (
                        <div class="col-md-6">
                          <label class="form-label fw-bold">Subscription</label>
                          <select
                            name="subscriptionType"
                            style={{
                              width: "100%",
                              padding: "0px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                              fontSize: "16px",
                              color: "#495057",
                              backgroundColor: "#fff",
                              height: "32px",
                            }}
                            value={this.state.planType}
                            onChange={this.handlePlanTypeChanges.bind(this)}
                          >
                            <option value="">Select Subscription</option>
                            {this.planTypeList.map((option, index) => (
                              <option key={index} value={option.type}>
                                {option.description}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <div class="col-md-6">
                          <label class="form-label fw-bold">
                            Texting Window
                          </label>
                          <input
                            title=""
                            required
                            type="number"
                            variant="outlined"
                            fullWidth
                            autoComplete="off"
                            id="name"
                            name="smsCredits"
                            className="form-control"
                            style={{ height: "32px", padding: "0px 8px" }}
                            value={this.state.validityDays}
                            onChange={this.handleValidityDaysChange.bind(this)}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      )}
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Status</label>
                        <select
                          name="planStatus"
                          value={this.state.planStatus}
                          onChange={this.handlePlanStatusChange.bind(this)}
                          style={{
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ced4da",
                            boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                            fontSize: "16px",
                            color: "#495057",
                            backgroundColor: "#fff",
                            height: "32px",
                          }}
                        >
                          <option value="">Select Status</option>
                          <option value="Active" id="1">
                            Active
                          </option>
                          <option value="InActive" id="2">
                            InActive
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label class="form-label fw-bold">SMS Credits</label>
                        <input
                          required
                          title=""
                          type="number"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="smsCredits"
                          className="form-control"
                          style={{ height: "32px", padding: "0px 8px" }}
                          value={this.state.smsCredits}
                          onChange={this.handleSmsCreditsChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-bold">
                          Plan Display Seq
                        </label>
                        <input
                          title=""
                          required
                          type="number"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="displaysequence"
                          className="form-control"
                          value={this.state.displaysequence}
                          onChange={this.handleDisplaySequenceChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                          style={{
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ced4da",
                            fontSize: "16px",
                            color: "#495057",
                            backgroundColor: "#fff",
                            height: "32px",
                          }}
                        />
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Overages Rate</label>
                        <input
                          required
                          title=""
                          type="text"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="smsCredits"
                          className="form-control"
                          style={{ height: "32px", padding: "0px 8px" }}
                          value={this.state.overagesRate}
                          onChange={this.handleOveragesRateChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>

                      <div class="col-md-6">
                        <label class="form-label fw-bold">Overages Block</label>
                        <input
                          required
                          title=""
                          type="text"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="smsCredits"
                          className="form-control"
                          style={{ height: "32px", padding: "0px 8px" }}
                          value={this.state.overagesBlocksize}
                          onChange={this.handleOveragesBlocksizeChange.bind(
                            this
                          )}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="p-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip title="Save plan" arrow>
                      <Button
                        type="submit"
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          fontSize: "26px",
                          cursor: "pointer",
                          borderRadius: "50%",
                          width: "45px",
                          height: "45px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0",
                          minWidth: "0",
                          border: "none",
                          margin: "0 5px",
                        }}
                      >
                        <FaCheck style={{ fontSize: "20px" }} />{" "}
                      </Button>
                    </Tooltip>

                    <Tooltip title="Cancel" arrow>
                      <Button
                        className="add"
                        style={{
                          backgroundColor: "#867e7e",
                          color: "white",
                          fontSize: "26px",
                          cursor: "pointer",
                          borderRadius: "50%",
                          width: "45px",
                          height: "45px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0",
                          minWidth: "0",
                          border: "none",
                          margin: "0 5px",
                        }}
                        onClick={this.backToViewAction.bind(this)}
                      >
                        <CancelIcon style={{ fontSize: "20px" }} />{" "}
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </>
    );
  }
  viewPlan() {
    return (
      <>
        <div className="row d-flex" style={{ height: "100%" }}>
          <div className="col-md-12">
            <div
              className="box"
              data-aos="zoom-in"
              data-aos-delay={100}
              style={{
                padding: "0em",
                position: "relative",
                height: "100%",
                overflow: "auto",
                // backgroundColor: "white",
                backgroundColor:
                  this.state.planStatus === "Active" ? "white" : "#f0f0f0", // grey for inactive
                opacity: this.state.planStatus === "Active" ? 1 : 0.6, // optional dimming effect
              }}
              id="regPlanBox"
            >
              <div className="plan-inner plan_card plan_card_bottom">
                <div
                  class="row"
                  className="entry-title plan_card planHeder"
                  style={{
                    background:
                      this.state.planStatus === "InActive"
                        ? "#cccccc"
                        : this.state.colorSecondary,
                  }}
                >
                  <div
                    className="icons"
                    style={{
                      position: "absolute",
                      top: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <>
                      <Tooltip title="Accounts" arrow>
                        <Badge
                          badgeContent={this.state.accountCount}
                          color="primary"
                          overlap="rectangular"
                        >
                          <MdManageAccounts
                            size="25px"
                            borderRadius="10px"
                            onClick={this.toPlanAccountDetails.bind(this, this.state.id)}
                            style={{ cursor: "pointer", margin: "0 5px" }}
                          />
                        </Badge>
                      </Tooltip>
                      <Tooltip title="Duplicate elsewhere" arrow>
                        <MoveUpIcon
                          style={{ cursor: "pointer" }}
                          onClick={this.handleMovePlanDetailsOpen.bind(
                            this,
                            this.state.id
                          )}
                        />
                      </Tooltip>
                      {(this.state.planType ===
                        SUBSCRIPTION_TYPES.customOnetime ||
                        this.state.planType ===
                        SUBSCRIPTION_TYPES.customYearly ||
                        this.state.planType ===
                        SUBSCRIPTION_TYPES.customMonthly) && (
                          <span
                            className="ms-2"
                            style={{ cursor: "pointer" }}
                            onClick={this.handleCustomerPlanOpenDialogBox.bind(
                              this,
                              this.state.id
                            )}
                          >
                            <Tooltip title="Send proposal to customer" arrow>
                              <EmailIcon style={{
                                color: "#fff",
                              }} />
                            </Tooltip>
                          </span>
                        )}
                    </>
                  </div>
                  <h3
                    className="plan_card"
                    style={{
                      padding: "40px 7px 7px 7px",
                      color: "#fff",
                      background: this.state.colorPrimary,
                    }}
                  >
                    <div style={{ display: "inline-block", textAlign: "center" }}>{this.state.name}</div>
                  </h3>
                  <div
                    className="price"
                    style={{
                      background:
                        this.state.planStatus === "InActive"
                          ? "#a6a6a6"
                          : this.state.colorPrimary,
                    }}
                  >
                    <span style={{ left: "20px", fontSize: "18px" }}>{`${this.state.currency?.symbol
                      }${Utils.formatWithCommas(this.state.price)}`}</span>
                  </div>
                  <div
                    className="icons"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <>
                      <Tooltip title="Duplicate here" arrow>
                        <ControlPointDuplicateIcon
                          style={{ cursor: "pointer", margin: "0 5px" }}
                          onClick={(e) =>
                            this.addDuplicatePlan(e, this.state.id)
                          }
                        />
                      </Tooltip>
                      <Tooltip title="Edit Plan" arrow>
                        <FaEdit
                          size="20px"
                          onClick={(e) => this.handleEditPlan(e, this.state.id)}
                          style={{ cursor: "pointer", margin: "0 5px" }}
                        />
                      </Tooltip>

                      <Tooltip title="Delete Plan" arrow>
                        <FaTrash
                          size="20px"
                          onClick={() => this.handleClickOpenDialogBox()}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    </>
                  </div>
                </div>
                <div className="entry-content" style={{ padding: "0px 15px" }}>
                  <ul>
                    {(this.state.planItems || []).map((planItem, i) => (
                      <>
                        {planItem.operation !== "DELETE" && (
                          <li
                            key={i}
                            style={{
                              padding: "0.2em",
                              fontWeight: planItem?.isFontBold && "600",
                              fontStyle: planItem?.isFontItalic && "italic",
                              fontSize: planItem?.isFontSmall && "12px",
                            }}
                          >
                            <p className="m-0">&nbsp;&nbsp;{planItem.name}</p>
                          </li>
                        )}
                      </>
                    ))}
                  </ul>
                </div>
                <hr></hr>
                <div className="p-3 pt-0">
                  <div class="row">
                    {!(
                      this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                      this.state.planType === SUBSCRIPTION_TYPES.payMonthly
                    ) && (
                        <div class="col-sm-12 text-start">
                          <div class="row d-flex">
                            <lable className="col-sm-3 form-label fw-bold m-0">
                              Subscription:
                            </lable>
                            <div className="col-sm-9">
                              {this.state.selectedPlanType?.description}
                            </div>
                          </div>
                        </div>
                      )}
                    <div class="col-sm-7 text-start">
                      {!(
                        this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                        this.state.planType === SUBSCRIPTION_TYPES.payMonthly
                      ) ? (
                        <div class="row d-block">
                          <lable className="form-label fw-bold">
                            Texting Window:
                          </lable>
                          <span className="p-0">
                            {this.state.validityDays?.toLocaleString()}
                          </span>
                        </div>
                      ) : (
                        <div class="row d-block">
                          <lable className="form-label fw-bold">
                            Subscription:
                          </lable>
                          <span className="p-0">
                            {this.state.selectedPlanType?.description}
                          </span>
                        </div>
                      )}
                      <div class="row d-block">
                        <lable className="form-label fw-bold">
                          SMS Credits:
                        </lable>
                        <span className="p-0">
                          {this.state.smsCredits?.toLocaleString()}
                        </span>
                      </div>
                      <div class="row d-block">
                        <lable className="form-label fw-bold">
                          Overages Rate:
                        </lable>
                        <span className="p-0">
                          {this.state.overagesRate?.toLocaleString()}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-5 text-start ps-0">
                      <div class="row d-block">
                        <lable className="form-label fw-bold">Status:</lable>
                        <span className="p-0">{this.state.planStatus}</span>
                      </div>
                      <div class="row d-block">
                        <lable className="form-label fw-bold">
                          Plan Display Seq:
                        </lable>
                        <span className="p-0">
                          {this.state.displaysequence}
                        </span>
                      </div>
                      <div class="row d-block">
                        <lable className="form-label fw-bold">
                          Overages Block:
                        </lable>
                        <span className="p-0">
                          {this.state.overagesBlocksize?.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={this.state.openDialogBox}
          onClose={this.handleCloseDialogBox.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="m-0" style={{ fontSize: "18px" }}>
                Are you sure about deleting
                <br></br>
                <span
                  style={{
                    color: " #37517e",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {this.state.name + "?"}
                </span>
              </p>
            </span>
          </DialogContent>
          <DialogActions
            style={{
              padding: "2em",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#37517e",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<SaveIcon />}
              onClick={(e) => this.handleDeletePlan(e, this.props.data.id)}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              size="large"
              style={{
                background: "#717373",
                color: "#fff",
                marginRight: "1rem",
                padding: "2px 10px",
                textTransform: "capitalize",
              }}
              startIcon={<CloseIcon />}
              onClick={this.handleCloseDialogBox.bind(this)}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.customerPlanOpen}
          onClose={this.handleCustomerPlanCloseDialogBox.bind(this)}
          style={{ padding: "1em" }}
          maxWidth="xl"
          className="CustomerviaEmailDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Send Proposal to Customer via Email</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleCustomerPlanCloseDialogBox.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.sendCustomPlanToCustomer.bind(this)}
          >
            <DialogContent>
              <div className="col-md-12 p-4 pt-3 pb-0">
                <div className="row">
                  <div className="col-md-12" id="assetFormLabel">
                    <label
                      className="form-label "
                      htmlFor="collapsible-lastname"
                    >
                      Customer First Name
                    </label>
                    <input
                      required
                      title=""
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      value={this.state.customerName}
                      onChange={this.handleCustomerNameChange.bind(this)}
                      validators={["required"]}
                      errormessages={["This field is required"]}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-12" id="assetFormLabel">
                    <label
                      className="form-label "
                      htmlFor="collapsible-lastname"
                    >
                      Customer Email
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control"
                      value={this.state.customerEmail}
                      onChange={this.handleCustomerEmailChange.bind(this)}
                      validators={["required"]}
                      errormessages={["This field is required"]}
                    />
                  </div>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <div class="col-md-12 text-center p-3">
                <Button
                  type="submit"
                  style={{
                    padding: "3px 10px",
                    background: "#37517e",
                    color: "#fff",
                    fontSize: "14px",
                    textTransform: "capitalize",
                  }}
                // onClick={(e) => this.sendCustomPlanToCustomer(e)}
                >
                  Send Email<i className="fa fa-paper-plane ms-2"></i>
                </Button>
              </div>
            </DialogActions>
          </ValidatorForm >
        </Dialog >
      </>
    );
  }
  createDuplicatePlan() {
    return (
      <div className="row d-flex" style={{ height: "100%" }}>
        <div className="col-md-12">
          <div
            className="box"
            data-aos="zoom-in"
            data-aos-delay={100}
            style={{
              padding: "0em",
              position: "relative",
              height: "100%",
              overflow: "auto",
              backgroundColor: "white",
            }}
            id="regPlanBox"
          >
            <div className="plan-inner plan_card plan_card_bottom">
              <ValidatorForm
                className="text-start"
                ref="form"
                onSubmit={this.addPlan.bind(this)}
              >
                <div
                  class="row"
                  className="entry-title plan_card"
                  style={{ background: this.state.colorSecondary }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      background: this.state.colorPrimary,
                    }}
                  >
                    <input
                      title=""
                      required
                      autoFocus={true}
                      type="text"
                      autoComplete="off"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Enter Plan Name"
                      value={this.state.name}
                      onChange={this.handlePlanNameChange.bind(this)}
                      validators={["required"]}
                      errormessages={["This field is required"]}
                      style={{
                        padding: "7px",
                        color: "#fff",
                        margin: "1% 10%",
                      }}
                    />
                  </div>
                  <div
                    className="price"
                    style={{
                      background: this.state.colorPrimary,
                    }}
                  >
                    <input
                      type="number"
                      name="price"
                      size="small"
                      title=""
                      required
                      value={this.state.price}
                      onChange={this.handlePlanPriceChange.bind(this)}
                      placeholder="$Price"
                      style={{
                        fontSize: "18px", // Set a smaller font size
                        width: "80px",
                        height: "40px",
                        marginleft: "9px",
                        borderRadius: "10px",
                        textAlign: "center",
                      }}
                    />
                  </div>
                </div>
                <div className="entry-content" style={{ padding: "0px 15px" }}>
                  <ul>
                    {this.state.planItems.length === 0 && (
                      <li style={{ padding: "0.5em" }}>
                        <div
                          className="row p-1"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "#ececec",
                          }}
                        >
                          <Tooltip title="Add Plan Item" arrow>
                            {" "}
                            <Button
                              style={{
                                background: "#37517e",
                                color: "#fff",
                                borderColor: "#37517e",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "32px",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                              }}
                              className="btn btn-info rounded-circle btn-sm"
                              type="button"
                              onClick={() => this.addPlanItem(0)}
                            >
                              <AddIcon
                                style={{
                                  fontSize: "16px",
                                  color: "#fff",
                                }}
                              />{" "}
                            </Button>
                          </Tooltip>
                        </div>
                      </li>
                    )}
                    {this.state.planItems.map((planItem, i) => (
                      <li key={i} style={{ padding: "0.5em" }}>
                        <div
                          class="row"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="col-md-2">
                            <input
                              type="number"
                              className="form-control"
                              style={{
                                width: "100%",
                                margin: "0 auto",
                                display: "block",
                                padding: "0.4375rem",
                                textAlign: "right",
                                height: "32px",
                              }}
                              value={planItem.displaysequence}
                              onChange={(e) =>
                                this.handlePlanItemDisplaySequenceChange(
                                  e,
                                  planItem,
                                  i
                                )
                              }
                              onFocus={(event) => {
                                event.target.select();
                              }}
                            />
                          </div>
                          <div className="col-md-7">
                            <input
                              title=""
                              type="text"
                              required
                              className="form-control"
                              style={{
                                fontWeight: planItem.isFontBold && "600",
                                fontStyle: planItem.isFontItalic && "italic",
                                fontSize: planItem.isFontSmall && "12px",
                                height: "32px",
                              }}
                              placeholder="Plan Item"
                              value={planItem.name}
                              autoFocus={true}
                              onChange={(e) =>
                                this.handlePlanItemNameChange(e, planItem, i)
                              }
                            />
                          </div>
                          <div
                            class="col-md-3 p-0"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              // justifyContent: "space-between",
                            }}
                          >
                            {i === this.state.planItems.length - 1 && (
                              <Tooltip title="Add Plan Item" arrow>
                                {" "}
                                <Button
                                  style={{
                                    background: "#37517e",
                                    color: "#fff",
                                    borderColor: "#37517e",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    width: "28px",
                                    height: "28px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    float: "right",
                                    padding: "0",
                                    minWidth: "0",
                                    border: "none",
                                  }}
                                  className="btn btn-info rounded-circle btn-sm me-1"
                                  type="button"
                                  onClick={() =>
                                    this.addPlanItem(planItem.displaysequence)
                                  }
                                >
                                  <AddIcon
                                    style={{
                                      fontSize: "16px",
                                      color: "#fff",
                                    }}
                                  />{" "}
                                </Button>
                              </Tooltip>
                            )}
                            <Button
                              className="add me-1"
                              style={{
                                background: "#867e7e",
                                color: "white",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                                marginleft: "2px",
                              }}
                              onClick={(e) =>
                                this.handleAccountDropdownOpen(e, planItem, i)
                              }
                            >
                              <MoreVertIcon style={{ fontSize: "16px" }} />
                            </Button>
                            <Button
                              className="add"
                              style={{
                                background: "#867e7e",
                                color: "white",
                                fontSize: "16px",
                                cursor: "pointer",
                                borderRadius: "50%",
                                width: "28px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                float: "right",
                                padding: "0",
                                minWidth: "0",
                                border: "none",
                                marginleft: "2px",
                              }}
                              onClick={this.planItemRemove.bind(
                                this,
                                planItem,
                                i
                              )}
                            >
                              <DeleteIcon style={{ fontSize: "16px" }} />{" "}
                            </Button>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  {this.textSetting()}
                </div>
                <hr></hr>
                <div style={{ padding: "0.4em 1em" }}>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Primary Color</label>
                      <MuiColorInput
                        format="hex"
                        variant="outlined"
                        size="small"
                        className="planMuiColorInput"
                        value={this.state.colorPrimary}
                        onChange={this.handleColorPrimaryChage.bind(this)}
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Secondary Color</label>
                      <MuiColorInput
                        format="hex"
                        variant="outlined"
                        size="small"
                        className="planMuiColorInput"
                        value={this.state.colorSecondary}
                        onChange={this.handleColorSecondaryChage.bind(this)}
                      />
                    </div>
                  </div>
                  {!(
                    this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                    this.state.planType === SUBSCRIPTION_TYPES.payMonthly
                  ) && (
                      <div class="row mt-2">
                        <div class="col-md-6">
                          <label class="form-label fw-bold">Subscription</label>
                          <select
                            name="subscriptionType"
                            style={{
                              width: "100%",
                              padding: "0px 8px",
                              borderRadius: "4px",
                              border: "1px solid #ced4da",
                              boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                              fontSize: "16px",
                              color: "#495057",
                              backgroundColor: "#fff",
                              height: "32px",
                            }}
                            value={this.state.planType}
                            onChange={this.handlePlanTypeChanges.bind(this)}
                          >
                            <option value="">Select Subscription</option>
                            {this.planTypeList.map((option, index) => (
                              <option key={index} value={option.type}>
                                {option.description}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                  <div class="row mt-2">
                    {this.state.planType === SUBSCRIPTION_TYPES.payYearly ||
                      this.state.planType === SUBSCRIPTION_TYPES.payMonthly ? (
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Subscription</label>
                        <select
                          name="subscriptionType"
                          style={{
                            width: "100%",
                            padding: "0px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ced4da",
                            boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                            fontSize: "16px",
                            color: "#495057",
                            backgroundColor: "#fff",
                            height: "32px",
                          }}
                          value={this.state.planType}
                          onChange={this.handlePlanTypeChanges.bind(this)}
                        >
                          <option value="">Select Subscription</option>
                          {this.planTypeList.map((option, index) => (
                            <option key={index} value={option.type}>
                              {option.description}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Texting Window</label>
                        <input
                          title=""
                          required
                          type="number"
                          variant="outlined"
                          fullWidth
                          autoComplete="off"
                          id="name"
                          name="smsCredits"
                          className="form-control"
                          style={{ height: "32px", padding: "0px 8px" }}
                          value={this.state.validityDays}
                          onChange={this.handleValidityDaysChange.bind(this)}
                          validators={["required"]}
                          errormessages={["This field is required"]}
                        />
                      </div>
                    )}
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Status</label>
                      <select
                        name="planStatus"
                        value={this.state.planStatus}
                        onChange={this.handlePlanStatusChange.bind(this)}
                        style={{
                          width: "100%",
                          padding: "0px 8px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.075)",
                          fontSize: "16px",
                          color: "#495057",
                          backgroundColor: "#fff",
                          height: "32px",
                        }}
                      >
                        <option value="">Select Status</option>
                        <option value="Active" id="1">
                          Active
                        </option>
                        <option value="InActive" id="2">
                          InActive
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">SMS Credits</label>
                      <input
                        required
                        title=""
                        type="number"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.smsCredits}
                        onChange={this.handleSmsCreditsChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Plan Display Seq</label>
                      <input
                        title=""
                        required
                        type="number"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="displaysequence"
                        className="form-control"
                        value={this.state.displaysequence}
                        onChange={this.handleDisplaySequenceChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                        style={{
                          width: "100%",
                          padding: "0px 8px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          fontSize: "16px",
                          color: "#495057",
                          backgroundColor: "#fff",
                          height: "32px",
                        }}
                      />
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-6">
                      <label class="form-label fw-bold">Overages Rate</label>
                      <input
                        required
                        title=""
                        type="text"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.overagesRate}
                        onChange={this.handleOveragesRateChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>

                    <div class="col-md-6">
                      <label class="form-label fw-bold">Overages Block</label>
                      <input
                        required
                        title=""
                        type="text"
                        variant="outlined"
                        fullWidth
                        autoComplete="off"
                        id="name"
                        name="smsCredits"
                        className="form-control"
                        style={{ height: "32px", padding: "0px 8px" }}
                        value={this.state.overagesBlocksize}
                        onChange={this.handleOveragesBlocksizeChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="p-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title="Save plan" arrow>
                    <Button
                      type="submit"
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "26px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                        minWidth: "0",
                        border: "none",
                        margin: "0 5px",
                      }}
                    >
                      <FaCheck style={{ fontSize: "20px" }} />{" "}
                    </Button>
                  </Tooltip>

                  <Tooltip title="Cancel" arrow>
                    {" "}
                    <Button
                      className="add"
                      style={{
                        backgroundColor: "#867e7e",
                        color: "white",
                        fontSize: "26px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                        minWidth: "0",
                        border: "none",
                        margin: "0 5px",
                      }}
                      onClick={this.planRemove.bind(this)}
                    >
                      <CancelIcon style={{ fontSize: "20px" }} />{" "}
                      {/* Adjust icon size */}
                    </Button>
                  </Tooltip>
                </div>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Plan);
